{
  "reportingConfiguration": {
    "title": "Reporting configuration",
    "information": "At regular intervals, a report will be sent to the contacts configured below.",
    "frequency": "Reporting frequency (in days)",
    "time": "Reporting time"
  },
  "recipients": {
    "title": "Recipients",
    "users": {
      "empty": "No recipients",
      "select": {
        "label": "Add recipients"
      },
      "add": {
        "label": "Add recipients",
        "notification": {
          "success": "The following recipients has been added"
        }
      },
      "remove": {
        "label": "Remove the selected recipients",
        "confirm": {
          "title": "Remove recipients",
          "message": "The following recipients will be removed:"
        },
        "notification": {
          "success": "The following recipients has been removed"
        }
      }
    }
  },
  "validation": {
    "frequency": {
      "required": "The reporting frequency is required"
    },
    "time": {
      "required": "The reporting time is required"
    }
  }
}
